/**
 * @desc 导入数据
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/listingQuote/dataImport`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
